import { render, staticRenderFns } from "./textEditer.vue?vue&type=template&id=90d01c5e&scoped=true"
import script from "./textEditer.vue?vue&type=script&lang=js"
export * from "./textEditer.vue?vue&type=script&lang=js"
import style0 from "./textEditer.vue?vue&type=style&index=0&id=90d01c5e&prod&lang=css"
import style1 from "./textEditer.vue?vue&type=style&index=1&id=90d01c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d01c5e",
  null
  
)

export default component.exports